import React from "react";
import { Link } from "react-router-dom";
import { IconButton } from "@chakra-ui/react";
import { FaChevronLeft } from "react-icons/fa";

const BackButton = ({ link }) => {
  const backLink = link ? link : "/chats";
  const clearLsCurrentChat = () => {
    if (backLink === "/chats") {
      localStorage.removeItem("vv-current-chat");
    }
  };
  return (
    <Link onClick={clearLsCurrentChat} to={backLink}>
      <IconButton
        icon={<FaChevronLeft />}
        variant="ghost"
        colorScheme="teal"
        size="sm"
        aria-label="Go back"
        _hover={{ bg: "teal.50" }}
      />
    </Link>
  );
};

export default BackButton;
